import React, { useMemo, useState } from 'react';
import { Box, Chip, Divider, TextField, Typography } from '@mui/material';
import DataTable from '../../components/design/DataTable.jsx';
import VButton from '../../design-system/components/VButton';
import VCard from '../../design-system/components/VCard';
import { colors, radius, shadows, motion } from '../../design-system/tokens';

export default function DesignSystemPage() {
  const [value, setValue] = useState('');

  const rows = useMemo(() => ([
    { name: 'colors.primary', value: colors.primary },
    { name: 'colors.secondary', value: colors.secondary },
    { name: 'colors.accent', value: colors.accent },
    { name: 'radius.md', value: `${radius.md}px` },
    { name: 'shadows.glowPrimary', value: shadows.glowPrimary },
    { name: 'motion.normal', value: `${motion.normal}ms` }
  ]), []);

  const columns = useMemo(() => ([
    { key: 'name', label: 'Token', render: (_, r) => r.name },
    { key: 'value', label: 'Valor', render: (_, r) => r.value }
  ]), []);

  return (
    <Box display="grid" gap={2}>
      <Box>
        <Typography variant="h5">Design System</Typography>
        <Typography variant="body2" color="text.secondary">Tokens e componentes base da VORTIQA</Typography>
      </Box>

      <VCard>
        <Box p={2} display="grid" gap={2}>
          <Typography variant="h6">Componentes</Typography>
          <Box display="flex" gap={1} flexWrap="wrap" alignItems="center">
            <VButton color="primary">Primary</VButton>
            <VButton color="secondary">Secondary</VButton>
            <VButton variant="outlined">Outlined</VButton>
            <VButton variant="text">Text</VButton>
            <Chip label="Realtime" color="primary" />
            <Chip label="Awaiting Approval" variant="outlined" />
            <Chip label="Success" color="success" />
            <Chip label="Warning" color="warning" />
            <Chip label="Error" color="error" />
          </Box>
          <Divider />
          <TextField label="Input" value={value} onChange={(e) => setValue(e.target.value)} />
          <TextField label="Multiline" value={value} onChange={(e) => setValue(e.target.value)} multiline minRows={3} />
        </Box>
      </VCard>

      <VCard>
        <Box p={2} display="grid" gap={1}>
          <Typography variant="h6">Tokens</Typography>
          <DataTable rows={rows} columns={columns} getKey={(r) => r.name} />
        </Box>
      </VCard>
    </Box>
  );
}

